import { Component, OnDestroy, OnInit, Renderer2, Inject } from '@angular/core';
import { SpinnerService } from '../core/services/spinner.service';
import { Subject } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { ApplicationConfigService } from '../core/services/application-config.service';

@Component({
    selector: 'app-frontend',
    templateUrl: './frontend.component.html',
    styleUrls: ['./frontend.component.css']
})
export class FrontendComponent implements OnInit, OnDestroy {

    showBackgroundImage = false;
    routeClassDefault = 'container';
    routeClass = this.routeClassDefault;

    protected onDestroy$ = new Subject();

    public showHeaderFooter = true;

    private isShowingHambergeMenu = false;
    private _body: HTMLElement;
    private readonly hamberMenuClass = 'nav-active';

    constructor(private renderer: Renderer2,
                private spinnerService: SpinnerService,
                private route: ActivatedRoute,
                private router: Router,
                public appConfig: ApplicationConfigService,
                private viewportScroller: ViewportScroller,
                @Inject(DOCUMENT) _document?: any) {
    }

    ngOnInit() {

        if (this.router.url.split('embeded').length == 2) {
            this.showHeaderFooter = false;
        }

        this.router.events.pipe(
            filter((e): e is Scroll => e instanceof Scroll),
            takeUntil(this.onDestroy$)
        ).subscribe((e: Scroll) => {
            let state = this.router.getCurrentNavigation().extras.state;
            if (state && state.skipScroll) return;
            if (e.position) {
                // backward navigation
                this.viewportScroller.scrollToPosition(e.position);
            } else if (e.anchor) {
                // anchor navigation
                this.viewportScroller.scrollToAnchor(e.anchor);
            } else {
                // forward navigation
                this.viewportScroller.scrollToPosition([0, 0]);
            }
        });

        this.renderer.addClass(document.body, 'frontend');
        this.renderer.addClass(document.body, 'sidebar-hidden');
        this.renderer.addClass(document.body, 'aside-menu-hidden');
        this.spinnerService.setupShowOnBodyUntil(this.renderer, this.onDestroy$);
        this.router.events
            .pipe(
                startWith('first'),
                filter(e => e == 'first' || (e instanceof NavigationEnd)),
                takeUntil(this.onDestroy$)
            )
            .subscribe(() => {
                let topChild = this.findLastChild();
                this.routeClass = this.findFirstData(topChild, 'routeClass') || this.routeClassDefault;

                if (!!this._body) {
                    this.isShowingHambergeMenu = false;
                    this._body.classList.remove(this.hamberMenuClass);
                }
            });

        this._body = document.getElementsByTagName('body')[0];
    }

    findLastChild() {
        let route = this.route;
        while (route.firstChild != null) {
            route = route.firstChild;
        }
        return route;
    }

    findFirstData(route: ActivatedRoute, param: string): any {
        while (route != null){
            if (param in route.snapshot.data) return route.snapshot.data[param];
            route = route.parent;
        }
        return undefined;
    }

    toggleHambergerMenu(){
        if(!this.isShowingHambergeMenu)
            this.renderer.addClass(document.body, this.hamberMenuClass);
        else
            this.renderer.removeClass(document.body, this.hamberMenuClass);        

        this.isShowingHambergeMenu = !this.isShowingHambergeMenu;
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();

        this.renderer.removeClass(document.body, 'frontend');
        this.renderer.removeClass(document.body, 'sidebar-hidden');
        this.renderer.removeClass(document.body, 'aside-menu-hidden');
    }


}
